import axios from 'axios';

/**
 * Returns users token from sessionStorage
 * @returns {string}
 */
export function userGetToken() {
	return sessionStorage.getItem('token');
}

/**
 * Login function.
 * Function takes UUID code wich are going to save in token
 * @param {string} uuid
 * @returns {*}
 */
export function userLogin(uuid) {
	const headers = userRequestHeaders();

	const endpoint = process.env.REACT_APP_API_URL;

	return axios({
		method: 'GET',
		url: endpoint + '/onlinetoken/' + uuid,
		headers: headers
	}).then(function(res) {
		if(res.data.token) {
			return Promise.resolve(res.data.token);
		} else {
			return Promise.reject();
		}
	}).catch(function(error) {
		return Promise.reject(error);
	});
}

/**
 * Is user logged in?
 * @returns {boolean}
 */
export function userLoggedin() {
	return sessionStorage.getItem('token') !== null && sessionStorage.getItem('token') !== '';
}

/**
 * Helper function of login, saves header info, if user is logged in
 * return info from cache
 * @param contentType
 * @returns Object
 */
export function userRequestHeaders(contentType) {
	if (typeof contentType === 'undefined') {
		contentType = "application/json";
	}

	const headers = {
		'Accept': 'application/json',
		'Content-Type': contentType
	};

	if (userLoggedin()) {
        headers["Authorization"] = "Bearer " + userGetToken();
	}

	return headers;
}
